var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export const problemSchema = {
    $schema: 'https://json-schema.org/draft/2020-12/schema',
    title: 'An RFC 7807 problem object',
    type: 'object',
    properties: {
        type: {
            type: 'string',
            format: 'uri-reference',
            description: 'A URI reference that identifies the problem type.'
        },
        title: {
            type: 'string',
            description: 'A short, human-readable summary of the problem type.'
        },
        status: {
            type: 'integer',
            description: 'The HTTP status code generated by the origin server for this occurrence of the problem.',
            minimum: 100,
            maximum: 599
        },
        detail: {
            type: 'string',
            description: 'A human-readable explanation specific to this occurrence of the problem.'
        },
        instance: {
            type: 'string',
            format: 'uri-reference',
            description: 'A URI reference that identifies the specific occurrence of the problem. It may or may not yield further information if dereferenced.'
        }
    }
};
// const validateProblemDetailsJSON = jsonValidator({
//   type: 'object',
//   title: 'Problem Details',
//   properties: {
//     type: {
//       type: 'string',
//       default: 'about:blank'
//     },
//     title: {
//       type: 'string'
//     },
//     status: {
//       type: 'integer',
//       pattern: '^[1-5](?:\\d{2})$'
//     },
//     detail: {
//       type: 'string'
//     },
//     instance: {
//       type: 'string'
//     }
//   }
// })
export function problemFromResponse(response) {
    return __awaiter(this, void 0, void 0, function* () {
        const contentType = response.headers.get('Content-Type');
        if (contentType !== 'application/problem+json') {
            return undefined;
        }
        const problem = yield response.json();
        // validateProblemDetailsJSON(problemDetails)
        return problem;
    });
}
